import React from 'react'
import { Icon } from '@shopify/polaris'
import { BuyButtonMajor, ImageMajor, ImagesMajor, MagicMajor, PlayMajor, PlayCircleMajor, SlideshowMajor } from '@shopify/polaris-icons'

export default function renderIcon(type, color) {
  switch (type) {
    case 'imagePost':
      return <Icon source={ImageMajor} color={color} />
    case 'carousel':
      return <Icon source={SlideshowMajor} color={color} />
    case 'videoPost':
      return <Icon source={PlayCircleMajor} color={color} />
    case 'story':
      return <Icon source={BuyButtonMajor} color={color} />
    case '30secMention':
      return <Icon source={PlayMajor} color={color} />
    case '1minMention':
      return <Icon source={PlayCircleMajor} color={color} />
    case 'youtubeShort':
      return <Icon source={MagicMajor} color={color} />
    default:
      return <Icon source={ImagesMajor} color={color} />
  }
}

